import React, { useContext, useEffect, useState } from 'react';
import { Stack, Text } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { ReactSelect } from '~/components';
import { useSeriesNumber } from '~/hooks/useSinisters/useSinisters';
import { SeriesNumber } from '~/types/sinisters';
import { FilterContext } from '~/contexts/FilterContext/FilterContext';

interface SearchSeriesNumberProps {
  onChangeObj?: (items?: SeriesNumber) => void;
  onChangeArr?: (items?: SeriesNumber[]) => void;
  isMulti?: boolean;
  label?: string;
  placeholder?: string;
  width?: string;
  isRequired?: boolean;
  labelFontSize?: string;
}
export const SearchSeriesNumber: React.VFC<SearchSeriesNumberProps> = ({
  onChangeObj,
  onChangeArr,
  isMulti = false,
  label = 'Para começar, busque ou digite o número de série do produto que precisa de ajuda:',
  placeholder = 'Número de série',
  width = '40%',
  isRequired = false,
  labelFontSize = '16px',
}) => {
  const { groups, headOffices, branches } = useContext(FilterContext);

  const [buscaNmrSerie, setBuscaNmrSerie] = React.useState<string>('');
  const [nmr_serie, setNmrSerie] = useState<SeriesNumber[]>([]);
  const {
    data: series,
    isLoading: isNmrSerieLoading,
    refetch,
    isError,
  } = useSeriesNumber(
    buscaNmrSerie,
    {
      onSuccess: r => {
        setNmrSerie(r.results);
      },
    },
    { groups, headOffices, branches },
  );
  const [selectedNmrSerie, setSelectedNmrSerie] = useState<
    SeriesNumber[] | SeriesNumber
  >([]);

  const [errorMessage, setErrorMessage] = useState<string>('');

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    setError,
    formState,
    clearErrors,
    control,
  } = useForm();
  const { errors } = formState;

  const handleSelectedNmrSerieChange = (
    items?: SeriesNumber[] | SeriesNumber,
  ) => {
    setSelectedNmrSerie(items || []);
    if (onChangeObj) {
      if (items === null) {
        onChangeObj(undefined);
        return;
      }
      onChangeObj && items && 'numero_serie' in items && onChangeObj(items);
    }
    clearErrors('nmr_serie');
  };

  useEffect(() => {
    refetch().then(r => {
      if (r.isError) {
        setErrorMessage(
          'Não há contratos ativos, logo não há nenhum número de série disponível.',
        );
        setNmrSerie([]);
      } else {
        setNmrSerie(r.data?.results || []);
      }
    });
  }, [groups, headOffices, branches, buscaNmrSerie]);

  const handleBuscaNmrSerieChange = (texto?: string) => {
    setBuscaNmrSerie(texto || '');
  };

  return (
    <>
      <ReactSelect
        required={isRequired}
        label={label}
        labelFontSize={labelFontSize}
        isMulti={isMulti}
        isClearable
        name="nmr_serie"
        isSearchable
        placeholder={placeholder}
        options={nmr_serie.map(it => {
          return {
            ...it,
            value: it.numero_serie,
            label: it.numero_serie,
          };
        })}
        value={selectedNmrSerie}
        isLoading={false}
        onChange={changes =>
          handleSelectedNmrSerieChange(changes as SeriesNumber[])
        }
        onInputChange={change => {
          handleBuscaNmrSerieChange(change);
        }}
        noOptionsMessage={({ inputValue }) =>
          isNmrSerieLoading ? 'Carregando...' : 'Nenhum resultado encontrado'
        }
        defaultStyle
        error={errors?.nmr_serie}
        styles={{
          menu: provided => ({
            ...provided,
            maxHeight: 250,
            width: `${width}`,
          }),
          menuList: provided => ({
            ...provided,
            maxHeight: 250,
          }),
          control: provided => ({
            ...provided,
            borderColor: errors?.nmr_serie ? '#E53E3E' : '',
            width: `${width}`,
          }),
        }}
      />
      {isError && (
        <Text fontSize="14px" color="red.500">
          {errorMessage}
        </Text>
      )}
    </>
  );
};
